import { createSelector } from 'reselect'

const getDoc = ({ doc = {} }, { alias }) => doc ? doc[alias] : undefined

export const makeGetDoc = () => createSelector([ getDoc ], doc => doc)



// WEBPACK FOOTER //
// ./src/selectors/static.js